/* eslint-disable no-case-declarations */
import { Reducer } from "redux";

import { SourceName } from "../sources/types";
import { LoadedSourceInfo } from "../types/global";

export const SET_SOURCE_DATA = "SET_SOURCE_DATA";
export const SET_SINGLE_SOURCE_CONFIG = "SET_SINGLE_SOURCE_CONFIG";
export const SET_SOURCES_REFRESHING = "SET_SOURCES_REFRESHING";

export type SourceState = {
  data: Partial<Record<SourceName, LoadedSourceInfo>>;
  loading: boolean;
  refreshing: boolean;
};

export const initialSourceState = {
  data: {},
  // Loading is whether we are loading it the first time and refreshing is
  // if we are loading it at all.
  loading: true,
  refreshing: true,
};

// Actions
type SetSourceDataAction = {
  type: typeof SET_SOURCE_DATA;
  payload: Partial<Record<SourceName, LoadedSourceInfo>>;
};

type SetSingleSourceConfigAction = {
  type: typeof SET_SINGLE_SOURCE_CONFIG;
  payload: Partial<Record<SourceName, LoadedSourceInfo>>;
};

type SetSourcesRefreshingAction = {
  type: typeof SET_SOURCES_REFRESHING;
  payload: any;
};

type SourceActions =
  | SetSourceDataAction
  | SetSingleSourceConfigAction
  | SetSourcesRefreshingAction;

const sourcesReducer: Reducer<SourceState, SourceActions> = (
  state = initialSourceState,
  action
): SourceState => {
  switch (action.type) {
    case SET_SOURCE_DATA:
      return {
        ...state,
        data: { ...action.payload },
        loading: false,
        refreshing: false,
      };

    case SET_SINGLE_SOURCE_CONFIG:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case SET_SOURCES_REFRESHING:
      return {
        ...state,
        refreshing: true,
      };
    default:
      return state;
  }
};

export default sourcesReducer;
